import axios from 'axios';

/**
 * 排班預覽的 API 薄封裝。
 *
 * 寫入一律 POST 並帶 CSRF header —— /api/sched/* 掛的是 web middleware，
 * 沒有 token 會被 419 擋掉。錯誤把後端訊息原樣丟出去給畫面顯示，
 * 後端訊息本來就是寫給店長看的（例如「這位同仁在 … 不具備『護理師』職能」）。
 */
const csrfToken = () =>
    (document.querySelector('meta[name="csrf-token"]') || {}).content || '';

const post = async (url, data) => {
    try {
        const res = await axios.post(url, data, {
            headers: { 'X-CSRF-TOKEN': csrfToken() },
        });
        return res.data;
    } catch (err) {
        const message =
            ((err.response || {}).data || {}).message || '操作失敗，請稍後再試';
        const error = new Error(message);
        error.status = (err.response || {}).status;
        throw error;
    }
};

export const fetchPreview = (year, month) =>
    axios.get('/api/sched/preview', { params: { year, month } }).then((res) => res.data);

export const fetchCandidates = (date, session, skillId) =>
    axios
        .get('/api/sched/cover-candidates', {
            params: { date, session, skill_id: skillId },
        })
        .then((res) => res.data);

export const assignCover = (date, session, userUuid, skillId, reason) =>
    post('/api/sched/cover', {
        date,
        session,
        user_uuid: userUuid,
        skill_id: skillId,
        reason: reason || '',
    });

export const removeCover = (id) => post('/api/sched/cover/remove', { id });
